<template>
  <div ref="googleLoginBtn" />
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);

export default {
  name: "GoogleLoginButton",
  data() {
    return {};
  },
  mounted: function () {
    window.google.accounts.id.initialize({
      client_id:
        "240420624722-7vn119ldtedd2b30dsll3ekaguouemm4.apps.googleusercontent.com",
      callback: this.handleCredentialResponse,
    });
    window.google.accounts.id.renderButton(this.$refs.googleLoginBtn, {
      type: "standard",
      size: "large",
      theme: "outline",
      text: "sign_in_with",
      shape: "rectangular",
      logo_alignment: "left",
    });
  },
  methods: {
    async handleCredentialResponse(response) {
      let that = this;
      $.ajax({
        url:
          that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + "/Htmlv2/LoginGoogle",
        type: "post",
        data: {
          credential: response.credential,
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          // 判斷結果
          if (res.ok) {
            Storage.set("ek_login_token", res.LoginToken, "1y");
            that.$swal({
              heightAuto: false,
              icon: "success",
              title: that.$t("登入成功"),
              showConfirmButton: false,
              timer: 1500,
              willClose: function () {
                // 轉到首頁
                that.$router.push("/");
              },
              allowOutsideClick: false,
            });
          } else if (res.error_msg) {
            var error_msg = JSON.parse(res.error_msg);
            that.$swal({
              heightAuto: false,
              title: that.$t("錯誤"),
              text: error_msg[i18n.locale],
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: that.$t("確定"),
            });
          }
        },
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/GoogleLoginButton.vue